import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Separator } from "../ui/separator";
import { useSiteConfig } from "../../contexts/SiteConfigContext";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Who Needs This", path: "/who-needs-this" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const Footer = () => {
  const { images, siteInfo, footer } = useSiteConfig();
  return (
    <footer className="bg-[#060609] border-t border-white/[0.04]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img
                src={images.logo}
                alt={siteInfo.name}
                className="h-16 w-auto logo-filter"
              />
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              {footer?.description || "Professional polygraph examination services across South Africa. Trusted by corporates, legal professionals, and individuals."}
            </p>
            <p className="text-[#DC2626] font-semibold text-sm tracking-[0.2em] uppercase">
              {siteInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-500 hover:text-[#DC2626] text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {[
                "Employment & HR",
                "Corporate Investigations",
                "Legal & Professional",
                "Private Matters",
                "Custom Requests",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-gray-500 hover:text-[#DC2626] text-sm transition-colors duration-200"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-6">
              Get In Touch
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-[#DC2626] mt-0.5 shrink-0" />
                <span className="text-gray-500 text-sm">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-[#DC2626] mt-0.5 shrink-0" />
                <span className="text-gray-500 text-sm">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#DC2626] mt-0.5 shrink-0" />
                <span className="text-gray-500 text-sm">
                  {siteInfo.location}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-4 w-4 text-[#DC2626] mt-0.5 shrink-0" />
                <span className="text-gray-500 text-sm">{siteInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-10 bg-white/[0.04]" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name}. {footer?.copyrightText || "All rights reserved."}
          </p>
          <p className="text-gray-600 text-xs">
            {footer?.complianceText || "POPIA Compliant • Professional & Confidential"}
          </p>
        </div>
      </div>
    </footer>
  );
};
